import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import Hero from '@/components/dtcPartnerships/Hero';
import { ComponentWrapper, ContentWrapper } from '@/components/dtcPartnerships/Landing/styles';
import { LandingDisplayProps } from '@/components/dtcPartnerships/shared/types';

import { LandingGridWrapper } from './styles';

const LegacyLandingDisplay = ({
	Component,
	activeScreen,
	errorData,
	isSubmitting,
	name,
	onAuthSuccess,
	onScreenChange,
	partnerDetails,
	redeem,
	requestAccessCall,
	supportUrl,
	userAccessCode,
	setUserAccessCode,
}: LandingDisplayProps) => {
	return (
		<ContentWrapper>
			<Hero activeScreen={activeScreen} partnerDetails={partnerDetails} />
			{Component && (
				<ComponentWrapper>
					<LandingGridWrapper allowOverflow id={MAIN_CONTENT_ID} el="main">
						<Component
							error={errorData}
							isSubmitting={isSubmitting}
							name={name}
							onScreenChange={onScreenChange}
							onSuccess={onAuthSuccess}
							partnerDetails={partnerDetails}
							redeem={redeem}
							requestAccessCall={requestAccessCall}
							supportUrl={supportUrl}
							userAccessCode={userAccessCode}
							setUserAccessCode={setUserAccessCode}
						/>
					</LandingGridWrapper>
				</ComponentWrapper>
			)}
		</ContentWrapper>
	);
};

export default LegacyLandingDisplay;
